import { FC } from 'react';
import { Controller, UseFormReturn } from 'react-hook-form';
import { ProductFormData } from '@src/types/productsAddons.ts';
import { Input, Switch } from '@features/ui';

export const ProductGeneralSettingsForm: FC<UseFormReturn<ProductFormData>> = ({
  control,
  formState: { errors },
}) => {
  return (
    <div className={'text-xs flex flex-col'}>
      <p className={'text-sm font-bold'}>General Settings</p>
      <div
        className={
          'flex xl:w-[80%] lg:flex-row flex-col w-full gap-x-[64px] gap-y-6 mt-[24px]'
        }
      >
        <Controller
          control={control}
          name="title"
          render={({ field }) => (
            <div className={'flex flex-1 flex-col gap-2'}>
              <p>Title</p>
              <Input
                error={!!errors?.title?.message}
                placeholder={'Enter'}
                textSize={'xs'}
                variant={'secondary'}
                {...field}
              />
            </div>
          )}
        />
        <Controller
          control={control}
          name="description"
          render={({ field }) => (
            <div className={'flex flex-1 flex-col gap-1'}>
              <p className={'mb-1'}>Description</p>
              <Input
                error={!!errors?.description?.message}
                placeholder={'Enter'}
                textSize={'xs'}
                variant={'secondary'}
                {...field}
              />
            </div>
          )}
        />
      </div>
      <Controller
        control={control}
        name="internal_notes"
        render={({ field }) => (
          <div
            className={
              'lg:w-[50%] w-full flex flex-col gap-y-5 lg:mt-[71px] mt-[24px]'
            }
          >
            <p>Internal Notes</p>
            <Input
              placeholder={'Enter'}
              textSize={'xs'}
              variant={'secondary'}
              {...field}
            />
          </div>
        )}
      />
      <div className={'flex flex-col gap-[22px] xl:w-[70%] w-full mt-[36px]'}>
        <p>Product Display Name</p>
        <div className={'flex lg:flex-row flex-col w-full gap-7.5'}>
          <Controller
            control={control}
            name="display_name_web"
            render={({ field }) => (
              <div className={'flex-1 flex flex-col gap-2.5'}>
                <p>Website</p>
                <Input
                  placeholder={'Enter'}
                  textSize={'xs'}
                  variant={'secondary'}
                  {...field}
                />
              </div>
            )}
          />
          <Controller
            control={control}
            name="display_name_app"
            render={({ field }) => (
              <div className={'flex-1 flex flex-col gap-2.5'}>
                <p>App</p>
                <Input
                  placeholder={'Enter'}
                  textSize={'xs'}
                  variant={'secondary'}
                  {...field}
                />
              </div>
            )}
          />
        </div>
      </div>
      <div className={'flex xl:w-[70%] w-full mt-[36px]'}>
        <Controller
          control={control}
          name={`is_visible_on_web`}
          render={({ field }) => (
            <div className={'flex flex-1 flex-col justify-center'}>
              <Switch
                checked={!!field.value}
                label={'Visible on website'}
                onCheckedChange={(value) => field.onChange(Boolean(value))}
              />
            </div>
          )}
        />
      </div>
      <div className={'flex xl:w-[70%] w-full mt-[36px]'}>
        <Controller
          control={control}
          name={`affiliate_eligible`}
          render={({ field }) => (
            <div className={'flex flex-1 flex-col justify-center'}>
              <Switch
                checked={!!field.value}
                label={'Affiliate Eligibility'}
                onCheckedChange={(value) => field.onChange(Boolean(value))}
              />
            </div>
          )}
        />
      </div>
    </div>
  );
};
